// Pure helpers for the Email Draft "Installer" dropdown. Kept DOM-free so they
// can be unit-tested; application.js does the actual <option> rendering and
// wires re-ordering to the delivery-state select.

// Orders installers so those in `state` come first (original order preserved
// within each group), then everyone else. A blank/unknown state leaves the list
// in file order. Case/spacing-insensitive on the state code.
export function orderInstallers(installers, state) {
  const s = String(state ?? '').trim().toUpperCase()
  if (!s) return [...installers]
  const match = []
  const rest = []
  for (const inst of installers) {
    if (String(inst.state ?? '').trim().toUpperCase() === s) match.push(inst)
    else rest.push(inst)
  }
  return [...match, ...rest]
}

// Human label for one option: "Name — Company (STATE)", dropping the company
// when absent ("Name (STATE)") and the state when absent ("Name").
export function installerLabel(inst) {
  const company = String(inst.company ?? '').trim()
  const state = String(inst.state ?? '').trim()
  const base = company ? `${inst.name} — ${company}` : String(inst.name ?? '')
  return state ? `${base} (${state})` : base
}
